import styled from 'styled-components'
import {
  Avatar as AntAvatar,
  Typography,
  Tag as AntTag,
  Button as AntButton,
  Space as AntSpace,
  Divider as AntDivider,
} from 'antd'
import { COLORS, SPACING, TYPOGRAPHY, BORDER_RADIUS, FONT_WEIGHT } from '../../../styles/theme'

/**
 * Styled components for UserMenu
 * Replaces inline styles with reusable, semantic components
 */

const { Text } = Typography

// Dropdown container
export const DropdownContainer = styled.div`
  min-width: 240px;
  padding: ${SPACING.md} 0;
  background-color: var(--color-bg-elevated);
  border-radius: ${BORDER_RADIUS.lg};
  box-shadow: var(--shadow-dropdown);
  transition:
    background-color 0.2s ease,
    box-shadow 0.2s ease;
`

// User info section
export const UserInfoSpace = styled(AntSpace)`
  &.ant-space {
    width: 100%;
    padding: 0 ${SPACING.lg};
  }
`

export const UserNameContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${SPACING.sm};
`

export const UserNameText = styled(Text)`
  &.ant-typography {
    font-size: ${TYPOGRAPHY.body.fontSize};
  }
` as typeof Text

export const RoleTag = styled(AntTag)`
  &.ant-tag {
    margin: 0;
  }
`

export const UserEmailText = styled(Text)`
  &.ant-typography {
    font-size: ${TYPOGRAPHY.caption.fontSize};
    display: block;
  }
` as typeof Text

// Divider
export const MenuDivider = styled(AntDivider)`
  &.ant-divider {
    margin: ${SPACING.md} 0;
  }
`

// Menu buttons container
export const MenuButtonsContainer = styled.div`
  padding: 0 ${SPACING.sm};
`

// Menu buttons
export const MenuButton = styled(AntButton)`
  &.ant-btn {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: ${SPACING.xs};
  }
`

export const LastMenuButton = styled(AntButton)`
  &.ant-btn {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
`

// Avatar
export const StyledAvatar = styled(AntAvatar)`
  cursor: pointer;
  background-color: ${COLORS.primary};
`

// Theme section
export const ThemeSection = styled.div`
  padding: 0 ${SPACING.lg};
`

export const ThemeSectionLabel = styled.div`
  font-size: ${TYPOGRAPHY.caption.fontSize};
  font-weight: ${FONT_WEIGHT.medium};
  color: ${COLORS.textSecondary};
  margin-bottom: ${SPACING.sm};
`
